import { useMutation } from '@tanstack/react-query'

import { updateFreeeSelectCompany } from '@src/api'
import { DefaultApiUpdateFreeeSelectCompanyRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useUpdateFreeeSelectCompany = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateFreeeSelectCompanyRequest) =>
      updateFreeeSelectCompany(axiosInstance, params),
  })
}
